/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_TitleInputs */

const es_privacy_policy_sharing_title = /** @type {(inputs: Privacy_Policy_Sharing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Comparticion y Divulgacion`)
};

const en_privacy_policy_sharing_title = /** @type {(inputs: Privacy_Policy_Sharing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Sharing and Disclosure`)
};

/**
* | output |
* | --- |
* | "5. Sharing and Disclosure" |
*
* @param {Privacy_Policy_Sharing_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_title = /** @type {((inputs?: Privacy_Policy_Sharing_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_title(inputs)
	return en_privacy_policy_sharing_title(inputs)
});
export { privacy_policy_sharing_title as "privacy_policy.sharing.title" }